import Mediator from 'gisw/Classes/Mediator';
import Result from 'gisw/Widgets/GenericSearch/Result';
import ResultSet from 'gisw/Widgets/GenericSearch/ResultSet';

/**
 * Probably should change this into a set of functions
 */
class SearchUtility {
  /**
   * @param {*} data
   */
  resultSetFromPids (data) {
    const mapping = {
      CamaField: 'PID',
      LayerName: 'Parcels',
      LayerField: 'PID'
    };

    return this.addMapping(data, mapping);
  }

  /**
   * @param {*} data
   * @param {import('./ResultSet').ResultSetMapping} mapping
   */
  // eslint-disable-next-line class-methods-use-this
  addMapping (data, mapping) {
    const resultSet = new ResultSet();
    resultSet.setSource(data.Source);

    for (let i = 0; i < data.Features.length; i++) {
      resultSet.addMapping(data.Features[i].Name, mapping);

      for (let j = 0; j < data.Features[i].Results.length; j++) {
        const result = new Result();
        result.fromControllerResult(data.Features[i].Results[j], mapping);
        resultSet.addResult(data.Features[i].Name, result);
      }
    }

    Mediator.handle({ name: 'loading.hide' });

    return resultSet;
  }
}

export default SearchUtility;
